export const EXAM_PREFRENCES_API_ROUTES = {
    GET_CLASS_LIST: "home/classList",
    GET_USER_CLASS_LIST: "user/classList",
    GET_BOARD_LIST: "user/boardList",
    GET_EXACT_BOARD_LIST: "user/ExactBoardList",
    GET_SUBJECT_LIST: "user/subjectList",
    SUBMIT_COURSE_PREF: "user/coursePreferances",
    EDUCATION_INTEREST: "user/educationInterestList",
    STATE_LIST: 'user/stateList',
    GET_CITY_LIST: 'user/cityList',
    GET_LANGUAGE_LIST: 'user/LanguageList',
    GET_USER_DETAILS_SIGNUP: 'user/userDetailssignup',
    GET_COURSE_PREFERENCES_SIGNUP: 'user/coursePreferancesssignup',
}